import { render, staticRenderFns } from "./QueryPrice.vue?vue&type=template&id=2d9a9a5b&scoped=true&"
import script from "./QueryPrice.vue?vue&type=script&lang=js&"
export * from "./QueryPrice.vue?vue&type=script&lang=js&"
import style0 from "./QueryPrice.vue?vue&type=style&index=0&id=2d9a9a5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9a9a5b",
  null
  
)

export default component.exports